"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HashBasedPeerSource = void 0;
const shuffling_1 = require("../../../../util/shuffling");
const containers_1 = require("../../../../data/containers");
const model_1 = require("../../../../data/model");
class HashBasedPeerSource {
    constructor(sources) {
        if (sources === undefined) {
            sources = [];
        }
        this.sources = sources.map(HashBasedPeerSource.toHashedPeerContainer);
    }
    addSource(source) {
        this.sources.push(HashBasedPeerSource.toHashedPeerContainer(source));
    }
    async getPeers(count) {
        let peers = await this.getPeersFromAllSources();
        shuffling_1.Shuffle.array(peers);
        if (peers.length > count) {
            peers = peers.slice(0, count);
        }
        return peers;
    }
    async getPeerForEndpoint(endpoint) {
        for (const source of this.sources) {
            let peerInfo = await HashBasedPeerSource.lookupEndpointInSource(endpoint, source);
            if (peerInfo !== undefined) {
                return peerInfo;
            }
        }
        return undefined;
    }
    static async lookupEndpointInSource(ep, source) {
        let hash = source.parseEndpoint(ep);
        let found = undefined;
        if (hash !== undefined) {
            if (source.items instanceof Map) {
                found = source.items.get(hash);
            }
            else if (source.items instanceof containers_1.MutableSet ||
                source.items instanceof model_1.HashedSet) {
                found = source.items.get(hash);
            }
            else {
                throw new Error('Unexpected type for peer source.items: ' + (typeof source.items));
            }
        }
        return found !== undefined ? await found.asPeer() : undefined;
    }
    async getPeersFromSource(source) {
        let ts;
        if (source.items instanceof Map) {
            ts = Array.from(source.items.values());
        }
        else if (source instanceof containers_1.MutableSet ||
            source instanceof model_1.HashedSet) {
            ts = Array.from(source.values());
        }
        else {
            throw new Error('Unexpected type for peer source: ' + (typeof source));
        }
        let pis = new Array();
        for (const t of ts) {
            pis.push(await t.asPeer());
        }
        return pis;
        //let x = ts.map((t:T) => t.asPeer());
        //return x.map(async (p: Promise<PeerInfo>) => await p);
    }
    async getPeersFromAllSources() {
        let result = [];
        for (const source of this.sources) {
            result = result.concat(await this.getPeersFromSource(source));
        }
        return result;
    }
    static toHashedPeerContainer(c) {
        let items = c.items instanceof model_1.HashedSet || c.items instanceof containers_1.MutableSet || c.items instanceof Map ?
            c.items : new Map(Array.from(c.items).map((t) => [t.hash(), t]));
        return { items: items, parseEndpoint: c.parseEndpoint };
    }
}
exports.HashBasedPeerSource = HashBasedPeerSource;
//# sourceMappingURL=ContainerBasedPeerSource.js.map